import { useQuery } from '@tanstack/react-query';
import { transactionInternalApi } from '../apis';
import { CAN_READ_TRANSACTION } from '../auth/permissions';
import { useMe } from '../organisation/useMe';

export const useCheckIfTransactionsExist = () => {
  const { permissions } = useMe();

  return useQuery({
    enabled: permissions.includes(CAN_READ_TRANSACTION),
    queryKey: ['checkIfTransactionsExist'],
    queryFn: async () => {
      const response = await transactionInternalApi.checkIfTransactionsExist();
      return (response as unknown as string) === 'true';
    },
    staleTime: Infinity,
  });
};
